import { AiSuggestionRequest, api } from "./api";

/** Asks the AI for a text to fill a field; rejects on error, timeout or cancel. */
export const requestAiSuggestion = (siteId: string, request: AiSuggestionRequest, signal?: AbortSignal) =>
  api.suggestText(siteId, request, signal);
